import { useTrackPageView } from '@sparknz/tracking';

export default function useTrackCartPageView() {
  useTrackPageView({
    pageID: 'shop.cartState',
    pageName: 'shop.cartState',
    breadcrumbs: ['home', 'shop'],
    primaryCategory: 'shop',
    pageType: 'Cart Page',
    isVisibleInNav: false,
    lastModifiedDate: Date.now(),
  });
}
